import * as config from '@/scripts/app-configs/config'
import { SYSTEM_STORAGE } from '@/scripts/app-configs/constants'

const languageFallback = config.get('LANGUAGE_FALLBACK')
const languageDefault = config.get('DEFAULT_LANGUAGE')

export default () => {
  const forceLanguage = config.get('FORCE_LANGUAGE') === true

  if (forceLanguage) {
    return forceLanguage
  }

  // If not forcing, consider local storage
  try {
    const { system } = JSON.parse(localStorage.getItem(SYSTEM_STORAGE.key))

    if (system.language) {
      return system.language
    }

  } catch (e) {
    if (!(e instanceof TypeError)) {
      throw e
    }
  }

  // If there's no language in storage, go to browser language
  // Check if client language available
  // If so, use it set language cookie to that one
  const browserLanguage = (navigator.language || navigator.userLanguage).split('-')[0]
  const availableLanguages = config.get('AVAILABLE_LANGUAGES').split(',')

  if (availableLanguages.includes(browserLanguage)) {
    return browserLanguage
  }

  // if not fitting any available language, fallback to default
  return languageFallback
}

export const languageOptions = [
  {
    optLabel: 'profile.personal_info.language.portuguese-pt',
    optValue: 'pt-PT',
  },
  {
    optLabel: 'profile.personal_info.language.english-us',
    optValue: 'en-US',
  },
  {
    optLabel: 'profile.personal_info.language.english-gb',
    optValue: 'en-GB',
  },
  {
    optLabel: 'profile.personal_info.language.english-ca',
    optValue: 'en-CA',
  },
  {
    optLabel: 'profile.personal_info.language.spanish-us',
    optValue: 'es-US',
  },
  {
    optLabel: 'profile.personal_info.language.french-ca',
    optValue: 'fr-CA',
  },
  {
    optLabel: 'profile.personal_info.language.portuguese',
    optValue: 'pt',
  },
  {
    optLabel: 'profile.personal_info.language.english',
    optValue: 'en',
  },
  {
    optLabel: 'profile.personal_info.language.spanish',
    optValue: 'es',
  },
]

export const languageMap = {
  'pt-PT': 'pt',
  'en-US': 'en',
  'en-GB': 'en',
  'en-CA': 'en',
  'es-US': 'es',
  'pt': 'pt-PT',
  'en': 'en-US',
  'es': 'es-US',
}

export const getLanguageOptions = () => {
  const availableLanguages = config.get('AVAILABLE_LANGUAGES_FOR_MEMBER').split(',')

  return languageOptions.filter((option) => availableLanguages.includes(option.optValue))
}

export const getLanguage = (lang) => {
  const languageOptions = getLanguageOptions()
  const language = languageOptions.find((option) => option.optValue.toLocaleLowerCase() === lang?.toLocaleLowerCase())

  if (language) {
    return language.optValue
  }

  return languageMap[lang] || languageDefault
}
